// extracted by mini-css-extract-plugin
export default {"wrapper":"Page_wrapper__E2vjW","container":"Page_container__DFZ+T"};